import React from 'react';
import tpl from '../templates/insurance';
import {View} from 'MWC';

export default class extends View {
    template = tpl;

    static displayName = 'Services.Insurance.Main';
}
